import React from 'react';
import {useTranslation} from "react-i18next";
import Punchcard from '../common/punchcard';
import BalancesView from "@/common/customer-balances/BalancesView";

const { Customer } = Mobi2Go;

const ComoModal = ({ closeModal }) => {
    const [t] = useTranslation('order.loyalty');
    const loyalty = Customer.getLoyalty('ComoLoyalty');

    const className = name =>
        `m2g-customer-loyalty-program-modal${name || ''}`;

    return (
        <>
            <BalancesView />
            {loyalty?.state?.punch_card_progress?.length > 0 && (
                <>
                    <h2 className={className('-punch-card-header')}>
                        {t('punch_cards')}
                    </h2>
                    <hr className={className('-line-break')} />
                    {loyalty.state.punch_card_progress.map(punchcard => {
                        return (
                            <Punchcard
                                key={punchcard.key}
                                title={punchcard.name}
                                description={punchcard.description}
                                num_punches_needed={punchcard.requiredPunches}
                                punches={punchcard.punches}
                            />
                        )
                    })}
                </>
            )}
        </>
    )
}

export default ComoModal;
